import React, { useState } from 'react';
import {
  login,
  getAclForUser,
  getUserProfile
} from '../../common/constants/api';
import { Formik, Field, Form, useField, isSubmitting } from 'formik';
import * as Yup from 'yup';
const Eye = '/images/icons/eye (1).svg';
const CloseEye = '/images/icons/slashEye.svg';
import { navigate } from 'gatsby';
import {
  MobileInputField,
  validatePhoneNumber,
  showHidePassword,
  Error
} from '@fincity-frontend/shared-ui';
import { setToken as loginTokenSetter } from '../../common/utils/auth-utils';
import { setAcl } from '../../common/utils/acl-utils';
import { setUserType } from '../../common/utils/cookie-utils';

const validationSchemaPhone = Yup.object().shape({
  phone: Yup.number('numbers only')
    .typeError("That doesn't look like a phone number")
    .positive("A phone number can't start with a minus")
    .integer("A phone number can't include a decimal point")
    .min(10, 'must be a 10 digit no')
    .required('A phone number is required'),
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .max(15, 'Password must not be longer than 15 characters')
    .required('Password is required')
    .matches(/[!@#$%^&*(),.?":{}|<>]/g, 'Must contain an Special Charecter')
});
const validationSchemaEmail = Yup.object().shape({
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .max(15, 'Password must not be longer than 15 characters')
    .required('Password is required')
    .matches(/[!@#$%^&*(),.?":{}|<>]/g, 'Must contain an Special Charecter'),
  email: Yup.string()
    .max(100, 'Email address is Too Long!')
    .required('Please Enter your email ID')
    .matches(
      /^([a-z 0-9\.-_]+)@([a-z 0-9-]+).([a-z]{2,8})(.[a-z]{2,8})?$/,
      'invalid email'
    )
});
const SignIn = props => {
  const [mobile, setMobile] = useState('');
  const inputLength = mobile.length;
  const [showEyeIcon, setShowEyeIcon] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const [email, setEmail] = useState('');
  const [disabled, setDisabled] = useState(false);

  const genericLogin = async (values, userType) => {
    login({
      username: values.username,
      userType: userType,
      password: values.password
    })
      .then(async ({ id, token, username, userType }) => {
        await loginTokenSetter({ id, token, username, userType });
        let aclUser = await getAclForUser();
        aclUser?.acl?.can_create_in_principle_sanction && !aclUser?.acl?.is_rm
          ? setUserType(2)
          : null;
        await setAcl(aclUser);
        // redirection based on user type
        let res = await getUserProfile();
        localStorage.setItem('userData', JSON.stringify(res));
        setDisabled(false);
        let url = new URL(window.location?.href);
        let isRedirectionUrl = url.searchParams.get('redirect');

        navigate(isRedirectionUrl || '/app/dashboard');
      })
      .catch(err => {
        if (err.response !== undefined) {
          setErrMsg(err.response.data.message);
        }
        setDisabled(false);
      });
  };

  //checking the first input of the phone no if someone modifies it later
  const firstDigitModified = mobile.length > 0 && !/[6-9]|\./.test(mobile[0]);
  const handleCheckedChange = e => {
    setChecked(e.target.checked);
  };
  return (
    <Formik
      initialValues={{ phone: '', password: '', email: '' }}
      validationSchema={
        props.loginFrom !== 'RM' ? validationSchemaPhone : validationSchemaEmail
      }
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        //login api call
        setDisabled(true);
        if (props.loginFrom !== 'RM') {
          values.username = values.phone;
          await genericLogin(values, 0);
        } else {
          values.username = values.email;
          await genericLogin(values, 1);
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting
      }) => (
        <>
          <Form
            autoComplete="off"
            className="flex-1 pb-2 mt-5 h-72 md:h-64 w-full max-w-xs mx-auto text-left"
            onSubmit={handleSubmit}
          >
            {props.loginFrom !== 'RM' ? (
              <React.Fragment>
                <MobileInputField
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setMobile={setMobile}
                  validatePhoneNumber={e => {
                    validatePhoneNumber(e, inputLength);
                  }}
                />

                {/* checking the first Digit the input */}
                {firstDigitModified ? (
                  <div>
                    <p className=" text-red-100 text-sm font-roboto">
                      First digit cant be {values.phone[0]}
                    </p>
                  </div>
                ) : null}
                <Error touched={touched.phone} message={errors.phone} />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <label className="block mt-6 relative">
                  <span className=" block text-xs capitalize">Email ID</span>
                  <div className="">
                    <div className="outer-div flex w-full ">
                      <input
                        className=" flex-1 placeholder-grey-placeholder form-input  rounded-sm mt-1  block w-full"
                        type="text"
                        id="email"
                        name="email"
                        placeholder="Enter your fincity email ID"
                        value={values.email}
                        onChange={e => {
                          handleChange(e);
                          setEmail(e.target.value);
                        }}
                        onBlur={e => {
                          handleBlur(e);
                        }}
                        required
                        minLength="8"
                        maxLength="100"
                      />
                    </div>
                  </div>
                </label>
                <Error touched={touched.email} message={errors.email} />
              </React.Fragment>
            )}
            <label className="block mt-6 relative">
              <span className=" block text-xs capitalize">Password</span>
              <div className="">
                <div className="outer-div flex w-full ">
                  <input
                    className=" showHide flex-1 placeholder-grey-placeholder form-input  rounded-sm mt-1  block w-full"
                    type="password"
                    id="password"
                    name="password"
                    placeholder="**********"
                    onChange={e => {
                      handleChange(e);
                    }}
                    onBlur={e => {
                      handleBlur(e);
                    }}
                    value={values.password}
                    required
                    minLength="8"
                    maxLength="15"
                  />

                  {/* showHidePassword */}
                  <img
                    className="absolute right-0 mt-2 h-8 w-10 pr-4"
                    onClick={() => {
                      showHidePassword();
                      setShowEyeIcon(!showEyeIcon);
                    }}
                    id="toggle"
                    src={showEyeIcon ? CloseEye : Eye}
                    alt="showPassword"
                  />

                  {/* showHidePassword */}
                  <img
                    className="absolute right-0 mt-2 h-8 w-10 pr-4"
                    onClick={() => {
                      showHidePassword();
                      setShowEyeIcon(!showEyeIcon);
                    }}
                    id="toggle"
                    src={showEyeIcon ? CloseEye : Eye}
                    alt="showPassword"
                  />
                </div>
              </div>
            </label>
            <Error touched={touched.password} message={errors.password} />
            <button
              id="submit"
              className="submitButton w-full uppercase"
              type="submit"
              disabled={
                disabled ||
                (props.loginFrom !== 'RM'
                  ? mobile.length < 10 ||
                    values.phone[0] == 0 ||
                    errors.password ||
                    errors.phone ||
                    firstDigitModified
                  : errors.email || errors.password || email == '')
              }
            >
              Sign In
            </button>
            <div className="text-red-200 mt-3 text-center">{errMsg}</div>
          </Form>
          <div className="mt-14 mx-auto tracking-normal text-sm font-roboto text-center">
            {props.loginFrom !== 'RM' ? (
              <button
                className="no-underline mx-auto  block text-green-500 hover:underline"
                onClick={() => navigate('/app/bp/forgotpassword')}
              >
                Forgot Password?
              </button>
            ) : (
              <button
                className="no-underline mx-auto  block text-green-500 hover:underline"
                onClick={() => navigate('/app/rm/forgotpassword')}
              >
                Forgot Password?
              </button>
            )}
          </div>
        </>
      )}
    </Formik>
  );
};

export default SignIn;
